import { PortletConfig } from '../../../../shared/components/portlet/portlet/portlet.component';

export const TEMPLATE_NOTIFICATION_CONSTANTS = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
  BUTTON_COUNT: 5,

  // Portlet configuration
  PORTLET_CONFIG: {
    title: 'Notifications',
    subtitle: 'Manage all notifications',
    icon: 'bi bi-notification',
    showHeader: true,
    noPadding: true,
    offsetHeight: 100,
    minHeight: 400,
    collapsible: false,
  } as PortletConfig,
};
